import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom'; // Importa useParams
import apiClient from '../../acciones/apiClient';
import "./editPro.css";

import { NavBar } from "../../componentes/navbar/index";
import iconoEditar from "../../img/iconoEditar.png";
import iconoEliminar from "../../img/iconoEliminar.png";
import { jwtDecode } from "jwt-decode";
import LoaderOverlay from '../../componentes/loader/loaderOverlay';
import EditorNovelas from '../../componentes/editorNovelas/editorNovelas';

export const EditarProyecto = () => {
    const [text, setText] = useState('');
    const [largeText, setLargeText] = useState('');
    const [isAdult, setIsAdult] = useState(false);
    const [activeSection, setActiveSection] = useState(null);

    const { id } = useParams(); // Captura el ID desde la URL
    const [proyecto, setProyecto] = useState(null); // Estado para almacenar el proyecto

    const [selectedVisibility, setSelectedVisibility] = useState('public'); // Inicializa en "public"
    const [selectedStatus, setSelectedStatus] = useState('en-emision'); // Inicializa en "en-emision"
    const [category, setCategory] = useState('');
    const [views, setViews] = useState();


    const [altName, setAltName] = useState(''); // Nombre alternativo
    const [author, setAuthor] = useState(''); // Autor
    const [year, setYear] = useState(''); // Año
    const [studio, setStudio] = useState(''); // Estudio


    const [temporadas, setTemporadas] = useState([]); // Lista de temporadas del proyecto
    const [newSeasonName, setNewSeasonName] = useState('');
    const [newSeasonIndex, setNewSeasonIndex] = useState('');
    const [selectedSeason, setSelectedSeason] = useState('');
    const [chapterTitle, setChapterTitle] = useState('');
    const [chapterIndex, setChapterIndex] = useState('');
    const [chapterFile, setChapterFile] = useState(null);

    const [, setSeasons] = useState([]);

    const [, setChapterCover] = useState(null);



    const [capitulos, setCapitulos] = useState([]); // Lista de capítulos según la temporada seleccionada
    const [filteredTemporadas, setFilteredTemporadas] = useState([]); // Temporadas filtradas
    const [searchName, setSearchName] = useState(''); // Búsqueda por nombre
    const [searchIndex, setSearchIndex] = useState(''); // Búsqueda por índice

    const [filteredCapitulos, setFilteredCapitulos] = useState([]); // Capítulos filtrados
    const [rango, setRango] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [descripcion, setDescripcion] = useState('');

    // const [imagenes, setImagenes] = useState([]); // Estado de imágenes

    useEffect(() => {
        // Carga los datos del proyecto
        const fetchProyecto = async () => {
            try {
                const token = localStorage.getItem("token");
                if (!token) throw new Error("No se encontró un token válido en localStorage.");

                const decodedToken = jwtDecode(token);
                const response = await apiClient.get(`/proyectos/${id}`);
                const data = response.data;

                setProyecto(data);
                setText(data.titulo);
                setLargeText(data.descripcion);
                setIsAdult(data.mayores_18);
                setSelectedVisibility(data.visibilidad); // Muestra la visibilidad actual
                setSelectedStatus(data.estado); // Muestra el estado actual
                setCategory(data.categoria || '');
                setViews(data.vistas);

                // Inicializar valores de la información general
                setAltName(data.nombre_alternativo || '');
                setAuthor(data.autor || '');
                setYear(data.año || '');
                setStudio(data.estudio || '');
                setRango(decodedToken.rango);
            } catch (error) {
                console.error('Error al cargar el proyecto:', error);
            }
        };

        fetchProyecto();
    }, [id]);

    // Cargar datos del proyecto y temporadas
    useEffect(() => {
        const fetchProyectoData = async () => {
            try {
                const temporadasResponse = await apiClient.get(`/temporadas/${id}`);
                setTemporadas(temporadasResponse.data);
                setFilteredTemporadas(temporadasResponse.data); // Sincroniza las temporadas filtradas

                if (temporadasResponse.data.length > 0) {
                    const firstSeasonId = temporadasResponse.data[0].temporada_id;
                    setSelectedSeason(firstSeasonId);
                    await fetchCapitulos(firstSeasonId); // Carga los capítulos de la primera temporada
                }
            } catch (error) {
                console.error('Error al cargar temporadas:', error);
            }
        };

        fetchProyectoData();
    }, [id]);


    useEffect(() => {
        const fetchSeasons = async () => {
            try {
                const response = await apiClient.get(`/temporadas/${id}`);
                console.log("Temporadas recibidas:", response.data); // Verifica el contenido
                setSeasons(response.data);
            } catch (error) {
                console.error('Error al obtener temporadas:', error);
            }
        };
        fetchSeasons();
    }, [id]);

    useEffect(() => {
        setFilteredCapitulos(capitulos); // Sincroniza los capítulos filtrados con los capítulos originales
    }, [capitulos]);

    // Obtener imágenes del capítulo
    // const fetchImagenes = async (capituloId) => {
    //     try {
    //         const response = await apiClient.get(`/capitulos/${capituloId}/imagenes`);
    //         setImagenes(response.data.imagenes);
    //     } catch (error) {
    //         console.error('Error al obtener imágenes:', error);
    //     }
    // };

    // // Cambiar estado del checkbox
    // const toggleCheckbox = (index) => {
    //     setImagenes((prev) =>
    //         prev.map((img, i) =>
    //             i === index ? { ...img, habilitada: !img.habilitada } : img
    //         )
    //     );
    // };

    // // Guardar cambios en visibilidad
    // const guardarCambiosImagenes = async () => {
    //     try {
    //         const capituloId = capitulos.find((cap) => cap.capitulo_id)?.capitulo_id;

    //         await apiClient.put(`/capitulos/${capituloId}/imagenes`, {
    //             imagenes: imagenes.map((img) => ({ ...img, habilitada: img.habilitada || false }))
    //         });

    //         alert('Visibilidad de imágenes actualizada');
    //     } catch (error) {
    //         console.error('Error al guardar cambios:', error);
    //     }
    // };


    const handleChapterSearch = (value, type) => {
        if (!value) {
            setFilteredCapitulos(capitulos); // Si el valor está vacío, muestra todos los capítulos
            return;
        }

        const filtered = capitulos.filter((cap) => {
            if (type === "name") {
                return cap.titulo.toLowerCase().includes(value.toLowerCase());
            } else if (type === "index") {
                return cap.numero_capitulo.toString().includes(value);
            }
            return false;
        });

        setFilteredCapitulos(filtered);
    };

    const toggleSection = (section) => {
        setActiveSection(activeSection === section ? null : section);
    };


    const [showModal, setShowModal] = useState(false);

    const handleSaveChanges = async () => {
        const updatedData = {};

        // Solo incluir campos que cambiaron
        if (text && text !== proyecto.titulo) updatedData.titulo = text;
        if (largeText && largeText !== proyecto.descripcion) updatedData.descripcion = largeText;
        if (isAdult !== proyecto.mayores_18) updatedData.mayores_18 = isAdult;
        if (selectedVisibility !== proyecto.visibilidad) updatedData.visibilidad = selectedVisibility;
        if (selectedStatus !== proyecto.estado) updatedData.estado = selectedStatus;
        if (category && category !== proyecto.categoria) updatedData.categoria = category;
        if (views && views !== proyecto.vistas) updatedData.vistas = views;


        if (Object.keys(updatedData).length === 0) {
            alert('No hay cambios para guardar.');
            return;
        }

        try {
            await apiClient.put(`/proyectos/${proyecto.proyecto_id}`, updatedData);
            alert('Proyecto actualizado con éxito.');
            window.location.reload();
        } catch (error) {
            console.error('Error al actualizar el proyecto:', error);
            alert('Error al actualizar el proyecto.');
        }
    };

    const handleDeleteChapter = async (capituloId) => {
        const confirmDelete = window.confirm("¿Estás seguro de que deseas eliminar este capítulo?");
        if (!confirmDelete) return;

        try {
            await apiClient.delete(`/capitulos/${capituloId}`);
            alert('Capítulo eliminado con éxito.');

            // Actualizar la lista de capítulos tras la eliminación
            setCapitulos(capitulos.filter((cap) => cap.capitulo_id !== capituloId));
        } catch (error) {
            console.error('Error al eliminar el capítulo:', error.response?.data || error.message);
            alert('Error al eliminar el capítulo.');
        }
    };

    // Conecta la función al ícono de eliminación


    const handleSaveGeneralInfo = async () => {
        const updatedData = {};

        // Solo agregar los cambios
        if (altName && altName !== proyecto.nombre_alternativo) updatedData.nombre_alternativo = altName;
        if (author && author !== proyecto.autor) updatedData.autor = author;
        if (year && year !== proyecto.año) updatedData.año = year;
        if (studio && studio !== proyecto.estudio) updatedData.estudio = studio;

        if (Object.keys(updatedData).length === 0) {
            alert('No hay cambios en la información general para guardar.');
            return;
        }

        try {
            await apiClient.put(`/proyectos/${proyecto.proyecto_id}`, updatedData);
            alert('Información general actualizada con éxito.');
            window.location.reload();
        } catch (error) {
            console.error('Error al actualizar la información general:', error);
            alert('Error al actualizar la información general.');
        }
    };

    // Crear una nueva temporada
    const handleCreateSeason = async () => {
        if (!newSeasonName || !newSeasonIndex) {
            alert('Por favor, completa todos los campos de la temporada.');
            return;
        }

        try {
            const response = await apiClient.post(`/temporadas`, {
                nombre: newSeasonName,
                index: newSeasonIndex,
                proyecto_id: id,
            });
            setTemporadas([...temporadas, response.data]); // Actualiza la lista de temporadas
            setNewSeasonName('');
            setNewSeasonIndex('');
            setShowModal(false);
            alert('Temporada creada con éxito.');
        } catch (error) {
            console.error('Error al crear temporada:', error);
        }
    };

    // Subir un nuevo capítulo
    const handleCreateChapter = async () => {
        setIsLoading(true);
        sessionStorage.setItem("proyecto_reciente", id);
        if (!selectedSeason || !chapterTitle || !chapterFile || !chapterIndex) {
            alert('Por favor, completa todos los campos del capítulo.');
            return;
        }

        const formData = new FormData();
        const portada = document.getElementById('coverUpload').files[0];

        formData.append('numero_capitulo', chapterIndex);
        formData.append('titulo', chapterTitle);
        formData.append('proyecto_id', id);
        formData.append('temporada_id', selectedSeason);
        formData.append('capitulo_zip', chapterFile);

        if (portada) {
            formData.append('portada_capitulo', portada);
        }

        try {
            const response = await apiClient.post(`/capitulos/nuevo-capitulo`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            console.log('Respuesta del servidor:', response.data);
            alert('Capítulo creado con éxito.');
        } catch (error) {
            console.error('Error al crear capítulo:', error.response?.data || error.message);
            alert('Error al crear el capítulo.');
        } finally {
            setIsLoading(false);
        }
    };



    const processImageToWebp = (file, quality = 0.9) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onload = () => {
                const img = new Image();
                img.src = reader.result;

                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');

                    canvas.width = img.width;
                    canvas.height = img.height;
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                    canvas.toBlob(
                        (blob) => resolve(blob),
                        'image/webp',
                        quality
                    );
                };

                img.onerror = (error) => reject(error);
            };

            reader.onerror = (error) => reject(error);
        });
    };

    const handleChapterCoverChange = async (e) => {
        const file = e.target.files[0];
        if (file) {
            try {
                const webpBlob = await processImageToWebp(file, 0.8); // Proceso con canvas
                setChapterCover(webpBlob);
            } catch (error) {
                console.error('Error al procesar la portada:', error);
            }
        }
    };


    const fetchCapitulos = async (seasonId) => {
        try {
            const capitulosResponse = await apiClient.get(`/capitulos/temporada/${seasonId}`);
            setCapitulos(capitulosResponse.data);
        } catch (error) {
            console.error('Error al cargar capítulos:', error);
        }
    };

    const handleSeasonSelect = async (seasonId) => {
        try {
            setSelectedSeason(seasonId); // Actualiza la temporada seleccionada
            if (seasonId) {
                const response = await apiClient.get(`/capitulos/temporada/${seasonId}`);
                console.log("Capítulos recibidos para la temporada:", response.data);
                if (response.data.length > 0) {
                    setCapitulos(response.data); // Actualiza los capítulos si hay resultados
                } else {
                    setCapitulos([]); // Limpia la tabla si no hay capítulos
                }
            } else {
                setCapitulos([]); // Limpia la tabla si no hay temporada seleccionada
            }
        } catch (error) {
            console.error("Error al obtener capítulos por temporada:", error);
            setCapitulos([]); // Limpia la tabla en caso de error
        }
    };


    const handleCreateNovelChapter = async (e) => {
        e.preventDefault();

        if (!selectedSeason || !chapterTitle || !chapterIndex) {
            alert('Por favor, completa todos los campos del capítulo.');
            return;
        }

        const formData = new FormData();
        const portada = document.getElementById('cover').files[0];
        //const description = document.getElementById('description').value;
        //const descripcion = descripcion;
        console.log("La descripcion es: ",descripcion);
        formData.append('numero_capitulo', chapterIndex);
        formData.append('titulo', chapterTitle);
        formData.append('descripcion', descripcion);
        formData.append('proyecto_id', id);
        formData.append('temporada_id', selectedSeason);

        if (portada) {
            try {
                const webpBlob = await processImageToWebp(portada, 0.8);
                formData.append('portada_capitulo', webpBlob);
            } catch (error) {
                console.error('Error al procesar la portada:', error);
                alert('Error al procesar la portada.');
                return;
            }
        }

        try {
            const response = await apiClient.post(`/capitulos/nuevo-capitulo`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            console.log('Respuesta del servidor:', response.data);
            alert('Capítulo de novela creado con éxito.');
            setChapterTitle('');
            setChapterIndex('');
            setDescripcion('');
            //document.getElementById('description').value = '';
            document.getElementById('cover').value = '';
        } catch (error) {
            console.error('Error al crear capítulo de novela:', error.response?.data || error.message);
            alert('Error al crear el capítulo.');
        }
    };



    if (!proyecto) {
        return <div>Cargando...</div>;
    }

    return (
        <div className="todoEditProyect">
            <NavBar />

            <div className="editProyec">
                <div className="portada-container">
                    <img
                        src={proyecto.portada || 'URL_IMAGEN_DEFECTO'}
                        alt={`Portada de ${proyecto.titulo}`}
                        className="portada"
                    />
                    <img
                        src={iconoEditar}
                        alt="Editar"
                        className="icono-editar"
                        onClick={() => alert('Función de edición de portada ya implementada.')}
                    />
                </div>

                <div className="inputTextosEdit">
                    <input
                        type="text"
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                        placeholder="Título..."
                    />
                    <textarea 
                        value={largeText}
                        onChange={(e) => setLargeText(e.target.value)}
                        placeholder="Descripción..."
                        rows="10"
                    />
                </div>

                <div className="form-container">
                    <div className="form-group">
                        <label>Serie para adulto</label>
                        <label className="switch">
                            <input
                                type="checkbox"
                                checked={isAdult}
                                onChange={() => setIsAdult(!isAdult)}
                            />
                            <span className="slider round"></span>
                        </label>
                    </div>

                    <div className="form-group">
                        <label>Visibilidad</label>
                        <select
                            value={selectedVisibility}
                            onChange={(e) => setSelectedVisibility(e.target.value)}
                        >
                            <option value="publico">Público</option>
                            <option value="privado">Privado</option>
                        </select>
                    </div>

                    <div className="form-group">
                        <label>Estado</label>
                        <select
                            value={selectedStatus}
                            onChange={(e) => setSelectedStatus(e.target.value)}
                        >
                            <option value="en-emision">En emisión</option>
                            <option value="finalizado">Finalizado</option>
                        </select>
                    </div>

                    <div className="form-group">
                        <label>Categoría</label>
                        <input
                            type="text"
                            value={category}
                            onChange={(e) => setCategory(e.target.value)}
                            placeholder="Categoría"
                        />
                    </div>
                    {rango !== "afiliado" && (
                        <div className="form-group">
                            <label>Vistas</label>
                            <input
                                type="number"
                                value={views}
                                onChange={(e) => setViews(Number(e.target.value))}
                                placeholder="Agregar Número"
                            />
                        </div>
                    )}
                    <button className="save-button" onClick={handleSaveChanges}>
                        Guardar
                    </button>
                </div>
            </div>

            <div className="sections">
                <div onClick={() => toggleSection('general')} className="section-title">
                    Información General
                </div>
                {activeSection === 'general' && (
                    <div className="section-content">
                        <div className="form-container">
                            <div className="form-group">
                                <label>Nombre alternativo</label>
                                <input
                                    type="text"
                                    value={altName}
                                    onChange={(e) => setAltName(e.target.value)}
                                    placeholder="Agregar texto"
                                />
                            </div>
                            <div className="form-group">
                                <label>Autor</label>
                                <input
                                    type="text"
                                    value={author}
                                    onChange={(e) => setAuthor(e.target.value)}
                                    placeholder="Agregar texto"
                                />
                            </div>
                            <div className="form-group">
                                <label>Año</label>
                                <input
                                    type="text"
                                    value={year}
                                    onChange={(e) => setYear(e.target.value)}
                                    placeholder="Agregar texto"
                                />
                            </div>
                            <div className="form-group">
                                <label>Estudio</label>
                                <input
                                    type="text"
                                    value={studio}
                                    onChange={(e) => setStudio(e.target.value)}
                                    placeholder="Agregar texto"
                                />
                            </div>
                            <button className="save-button" onClick={handleSaveGeneralInfo}>
                                Guardar
                            </button>
                        </div>
                    </div>
                )}
                <br />
                <div onClick={() => setActiveSection('chapters')} className="section-title">Lista de Capítulos</div>
                {activeSection === 'chapters' && (
                    <div className="section-content">
                        <div className="app-container">
                            <div className="form-section">
                                <div className="form-group">
                                    <label>Selector de Temporada</label>
                                    <select
                                        value={selectedSeason}
                                        onChange={(e) => handleSeasonSelect(e.target.value)}
                                    >
                                        <option value="">Seleccionar Temporada</option>
                                        {filteredTemporadas.map(temp => (
                                            <option key={temp.temporada_id} value={temp.temporada_id}>
                                                {temp.nombre} - Índex: {temp.index}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label>Buscar por Nombre</label>
                                    <input
                                        type="text"
                                        placeholder="Nombre de Capítulo"
                                        value={searchName}
                                        onChange={(e) => {
                                            setSearchName(e.target.value);
                                            handleChapterSearch(e.target.value, "name");
                                        }}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Buscar por Índex</label>
                                    <input
                                        type="text"
                                        placeholder="Índex de Capítulo"
                                        value={searchIndex}
                                        onChange={(e) => {
                                            setSearchIndex(e.target.value);
                                            handleChapterSearch(e.target.value, "index");
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="table-section">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Nombre del capítulo</th>
                                            <th>Eliminar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredCapitulos.length > 0 ? (
                                            filteredCapitulos.map((cap) => (
                                                <tr key={cap.capitulo_id}>
                                                    <td>{cap.capitulo_id}</td>
                                                    <td>{cap.titulo}</td>
                                                    <td>
                                                        <img
                                                            src={iconoEliminar}
                                                            alt="Eliminar"
                                                            className="icono"
                                                            onClick={() => handleDeleteChapter(cap.capitulo_id)}
                                                        />
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="4">No hay capítulos disponibles.</td>
                                            </tr>
                                        )}
                                    </tbody>

                                </table>
                            </div>
                        </div>
                    </div>
                )}
                <br />
                <div onClick={() => toggleSection('new-chapter')} className="section-title">Nuevo Capítulo</div>
                {activeSection === 'new-chapter' && (
                    <div className="section-content">
                        {proyecto && proyecto.tipo_serie === 'novela' ? (
                            // Contenido para novelas
                            <div className="containerNuevaNovela">
                                <form onSubmit={handleCreateNovelChapter}>
                                    <div className="form-groupNovela">
                                        <label htmlFor="cover">Portada</label>
                                        <input type="file" id="cover" name="cover" />
                                    </div>
                                    <div className="form-groupNovela">
                                        <label htmlFor="chapterName">Nombre Capítulo</label>
                                        <input
                                            type="text"
                                            id="chapterName"
                                            name="chapterName"
                                            placeholder="Agregar texto"
                                            value={chapterTitle}
                                            onChange={(e) => setChapterTitle(e.target.value)}
                                        />
                                    </div>
                                    <div className="form-groupNovela">
                                        <label htmlFor="index">Index</label>
                                        <input
                                            type="text"
                                            id="index"
                                            name="index"
                                            placeholder="Agregar texto"
                                            value={chapterIndex}
                                            onChange={(e) => setChapterIndex(e.target.value)}
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="description">Descripción</label>
                                        <EditorNovelas value={descripcion} onChange={setDescripcion} />
                                    </div>
                                    <div className="form-groupManhwa">
                                        <label htmlFor="seasonSelect">Temporada</label>
                                        <select
                                            id="seasonSelect"
                                            value={selectedSeason}
                                            onChange={(e) => setSelectedSeason(e.target.value)}
                                        >
                                            <option value="">Seleccionar Temporada</option>
                                            {temporadas.map((temp) => (
                                                <option key={temp.temporada_id} value={temp.temporada_id}>
                                                    {temp.nombre} - Índex: {temp.index}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="form-groupManhwa">
                                        <button
                                            onClick={() => setShowModal(true)}
                                            className="new-season-button"
                                        >
                                            Nueva Temporada
                                        </button>
                                    </div>
                                    <button
                                        type="submit"
                                        className="submit-buttonNovela"
                                    >
                                        Crear Capítulo
                                    </button>
                                </form>

                                {showModal && (
                                    <div className="modalManhwa">
                                        <div className="modal-contentManhwa">
                                            <div className="form-groupManhwa">
                                                <label htmlFor="seasonName">Nombre de Temporada</label>
                                                <input
                                                    type="text"
                                                    id="seasonName"
                                                    placeholder="Agregar texto"
                                                    value={newSeasonName}
                                                    onChange={(e) => setNewSeasonName(e.target.value)}
                                                />
                                            </div>
                                            <div className="form-groupManhwa">
                                                <label htmlFor="seasonIndex">Index</label>
                                                <input
                                                    type="text"
                                                    id="seasonIndex"
                                                    placeholder="Agregar texto"
                                                    value={newSeasonIndex}
                                                    onChange={(e) => setNewSeasonIndex(e.target.value)}
                                                />
                                            </div>
                                            <button
                                                onClick={handleCreateSeason}
                                                className="add-season-button"
                                            >
                                                Agregar
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ) : (
                            // Contenido para manhwas
                            <div className="manhwa-form">
                                <div className="form-sectionManhwa">
                                    <div className="form-item">
                                        <label htmlFor="coverUpload">Portada</label>
                                        <input
                                            type="file"
                                            id="coverUpload"
                                            onChange={handleChapterCoverChange}
                                        />
                                    </div>
                                    <div className="form-item">
                                        <label htmlFor="chapterUpload">Capítulo ZIP</label>
                                        <input
                                            type="file"
                                            id="chapterUpload"
                                            onChange={(e) => setChapterFile(e.target.files[0])}
                                        />
                                    </div>
                                </div>
                                <div className="form-groupManhwa">
                                    <label htmlFor="chapterName">Nombre Capítulo</label>
                                    <input
                                        type="text"
                                        id="chapterName"
                                        placeholder="Agregar texto"
                                        value={chapterTitle}
                                        onChange={(e) => setChapterTitle(e.target.value)}
                                    />
                                </div>
                                <div className="form-groupManhwa">
                                    <label htmlFor="chapterIndex">Index</label>
                                    <input
                                        type="text"
                                        id="chapterIndex"
                                        placeholder="Agregar texto"
                                        value={chapterIndex}
                                        onChange={(e) => setChapterIndex(e.target.value)}
                                    />
                                </div>
                                <div className="form-groupManhwa">
                                    <label htmlFor="seasonSelect">Temporada</label>
                                    <select
                                        id="seasonSelect"
                                        value={selectedSeason}
                                        onChange={(e) => setSelectedSeason(e.target.value)}
                                    >
                                        <option value="">Seleccionar Temporada</option>
                                        {temporadas.map((temp) => (
                                            <option key={temp.temporada_id} value={temp.temporada_id}>
                                                {temp.nombre} - Índex: {temp.index}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-groupManhwa">
                                    <button
                                        onClick={() => setShowModal(true)}
                                        className="new-season-button"
                                    >
                                        Nueva Temporada
                                    </button>
                                </div>
                                <button onClick={handleCreateChapter}>
                                    Crear Capítulo
                                </button>

                                {/* loader global */}
                                {isLoading && <LoaderOverlay message="Creando capítulo..." />}
                                {showModal && (
                                    <div className="modalManhwa">
                                        <div className="modal-contentManhwa">
                                            <div className="form-groupManhwa">
                                                <label htmlFor="seasonName">Nombre de Temporada</label>
                                                <input
                                                    type="text"
                                                    id="seasonName"
                                                    placeholder="Agregar texto"
                                                    value={newSeasonName}
                                                    onChange={(e) => setNewSeasonName(e.target.value)}
                                                />
                                            </div>
                                            <div className="form-groupManhwa">
                                                <label htmlFor="seasonIndex">Index</label>
                                                <input
                                                    type="text"
                                                    id="seasonIndex"
                                                    placeholder="Agregar texto"
                                                    value={newSeasonIndex}
                                                    onChange={(e) => setNewSeasonIndex(e.target.value)}
                                                />
                                            </div>
                                            <button
                                                onClick={handleCreateSeason}
                                                className="add-season-button"
                                            >
                                                Agregar
                                            </button>
                                            <button
                                                onClick={() => setShowModal(false)}
                                                className="cancel-button"
                                            >
                                                Cancelar
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                )}
                <br />
                {/* <div onClick={() => toggleSection('pages')} className="section-title">Páginas</div>
                {activeSection === 'pages' && (
                    <div className="section-content">
                        <div className="form-group">
                            <label>Seleccionar Temporada</label>
                            <select onChange={(e) => handleSeasonSelect(e.target.value)}>
                                <option value="">Selecciona una Temporada</option>
                                {temporadas.map((temp) => (
                                    <option key={temp.temporada_id} value={temp.temporada_id}>
                                        {temp.nombre} - {temp.index}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="form-group">
                            <label>Seleccionar Capítulo</label>
                            <select onChange={(e) => fetchImagenes(e.target.value)}>
                                <option value="">Selecciona un Capítulo</option>
                                {capitulos.map((cap) => (
                                    <option key={cap.capitulo_id} value={cap.capitulo_id}>
                                        Capítulo {cap.numero_capitulo}: {cap.titulo}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="imagenes-lista">
                            {imagenes.map((img, index) => (
                                <div key={index} className="imagen-item">
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={img.habilitada}
                                            onChange={() => toggleCheckbox(index)}
                                        />
                                        Imagen {index + 1}
                                    </label>
                                </div>
                            ))}
                        </div>
                        <button onClick={guardarCambiosImagenes}>Guardar Cambios</button>
                    </div>
                )} */}

            </div>
        </div >
    )
}
